import React, { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

interface Article {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
  status: 'published' | 'draft';
}

export default function NewsPage() {
  const [articles, setArticles] = useState<Article[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('全部');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const articlesPerPage = 9;

  const categories = ['全部', '行业动态', '技术创新', '案例分享', '市场趋势', '解决方案', '公司动态'];

  useEffect(() => {
    // 初始化文章数据（与管理后台保持一致）
    const initialArticles: Article[] = [
      {
        id: 1,
        category: '行业动态',
        title: '2025年碳中和政策解读：企业如何抓住绿色发展机遇',
        excerpt: '随着国家碳达峰碳中和目标的深入推进，新的政策法规为企业带来了前所未有的发展机遇。本文深入解析最新政策要点，为企业制定绿色发展战略提供指导。',
        content: '随着国家碳达峰碳中和目标的深入推进，2025年新的政策法规为企业带来了前所未有的发展机遇。政府出台了一系列支持政策，包括绿色金融、税收优惠、技术补贴等措施，为企业绿色转型提供强有力的支持。\n\n企业应该如何抓住这些机遇？首先，要深入理解政策内容，制定符合自身发展的绿色战略；其次，要积极投入清洁技术研发，提升企业核心竞争力；最后，要建立完善的碳管理体系，实现精准减排。',
        date: '2025-01-15',
        readTime: '5分钟阅读',
        image: 'https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20discussing%20carbon%20neutrality%20policies%20with%20charts%20and%20graphs%20about%20green%20development%20opportunities%2C%20corporate%20executives%20analyzing%20environmental%20regulations%2C%20modern%20conference%20room%20with%20sustainability%20presentations&width=400&height=300&seq=news-001&orientation=landscape',
        tags: ['政策解读', '碳中和', '绿色发展'],
        status: 'published'
      },
      {
        id: 2,
        category: '技术创新',
        title: '区块链技术在碳资产管理中的创新应用实践',
        excerpt: '探索区块链技术如何革命性地改变碳资产管理模式，提升交易透明度和可信度，为碳市场发展注入新动力。',
        content: '区块链技术在碳资产管理领域的应用正在迎来突破性进展。通过去中心化的特性，区块链能够确保碳资产交易的透明性和不可篡改性，大大提升了市场信任度。\n\n具体应用包括：碳信用的数字化确权、智能合约自动执行交易、供应链碳足迹追踪等。这些创新应用不仅提高了交易效率，还降低了管理成本，为碳市场的健康发展奠定了技术基础。',
        date: '2025-01-12',
        readTime: '7分钟阅读',
        image: 'https://readdy.ai/api/search-image?query=Blockchain%20technology%20applied%20to%20carbon%20asset%20management%20with%20digital%20networks%2C%20cryptocurrency%20interfaces%20showing%20carbon%20credits%2C%20secure%20trading%20platforms%2C%20futuristic%20fintech%20environment%20with%20green%20technology%20elements&width=400&height=300&seq=news-002&orientation=landscape',
        tags: ['区块链', '碳资产', '技术创新'],
        status: 'published'
      },
      {
        id: 3,
        category: '案例分享',
        title: '某大型制造企业碳中和转型成功案例解析',
        excerpt: '深度分析一家大型制造企业如何通过系统性的碳减排策略，成功实现生产过程的绿色转型，为同行业提供宝贵经验。',
        content: '本案例深入分析了一家年产值超过100亿元的大型制造企业的碳中和转型历程。该企业通过制定科学的减排目标、投资清洁能源、优化生产工艺、建立碳管理体系等多重举措，在三年内实现了碳排放强度降低40%的显著成效。\n\n该企业的成功经验包括：建立完善的碳排放监测体系、实施能源结构优化、推进循环经济模式、加强供应链碳管理等。这些经验为同行业企业提供了可借鉴的转型路径。',
        date: '2025-01-10',
        readTime: '6分钟阅读',
        image: 'https://readdy.ai/api/search-image?query=Large%20manufacturing%20company%20successful%20carbon%20neutrality%20transformation%20with%20green%20factory%20facilities%2C%20renewable%20energy%20installations%2C%20clean%20production%20lines%2C%20environmental%20monitoring%20systems%2C%20industrial%20sustainability%20showcase&width=400&height=300&seq=news-003&orientation=landscape',
        tags: ['案例分析', '制造业', '转型成功'],
        status: 'published'
      },
      {
        id: 4,
        category: '市场趋势',
        title: '全球碳市场发展趋势及投资机会分析',
        excerpt: '全面解析全球碳市场的最新发展动态，分析未来投资热点和商业机会，为投资者和企业决策提供参考。',
        content: '全球碳市场正处于快速发展期，2024年全球碳市场交易规模突破1万亿美元大关。欧盟碳市场、中国全国碳市场、加州碳市场等主要碳市场均呈现稳步增长态势。\n\n未来投资机会主要集中在：碳捕获与封存技术、可再生能源项目、森林碳汇开发、碳金融衍生品等领域。投资者需要关注政策变化、技术进步、市场供需等因素，制定科学的投资策略。',
        date: '2025-01-08',
        readTime: '8分钟阅读',
        image: 'https://readdy.ai/api/search-image?query=Global%20carbon%20market%20trends%20analysis%20with%20financial%20charts%2C%20investment%20opportunities%20visualization%2C%20international%20trading%20platforms%2C%20market%20data%20displays%2C%20professional%20financial%20analysis%20environment&width=400&height=300&seq=news-004&orientation=landscape',
        tags: ['市场分析', '投资机会', '全球趋势'],
        status: 'published'
      },
      {
        id: 5,
        category: '解决方案',
        title: '智慧城市低碳发展的综合解决方案探讨',
        excerpt: '探讨如何通过智慧城市建设实现城市低碳发展目标，分析技术路径和实施策略，为城市管理者提供决策支持。',
        content: '智慧城市建设为城市低碳发展提供了新的技术路径和解决方案。通过物联网、大数据、人工智能等技术的综合应用，可以实现城市能源、交通、建筑等各领域的精细化管理和优化。\n\n主要解决方案包括：智慧能源管理系统、智慧交通调度系统、绿色建筑管理平台、环境监测网络等。这些解决方案能够显著提升城市运行效率，降低碳排放强度，推动城市可持续发展。',
        date: '2025-01-05',
        readTime: '9分钟阅读',
        image: 'https://readdy.ai/api/search-image?query=Smart%20city%20low%20carbon%20development%20comprehensive%20solutions%20with%20urban%20planning%20models%2C%20renewable%20energy%20infrastructure%2C%20intelligent%20transportation%20systems%2C%20green%20buildings%2C%20sustainable%20city%20management%20technologies&width=400&height=300&seq=news-005&orientation=landscape',
        tags: ['智慧城市', '低碳发展', '解决方案'],
        status: 'published'
      },
      {
        id: 6,
        category: '公司动态',
        title: '捷碳科技荣获"年度最佳低碳技术服务商"奖项',
        excerpt: '在2025年度低碳技术创新大会上，捷碳科技凭借在碳减排技术服务领域的卓越表现，荣获"年度最佳低碳技术服务商"殊荣。',
        content: '2025年1月3日，在北京举办的2025年度低碳技术创新大会上，捷碳科技凭借在碳减排技术服务领域的卓越表现，荣获"年度最佳低碳技术服务商"殊荣。\n\n此次获奖充分体现了行业和社会对捷碳科技专业能力和服务质量的认可。公司将继续致力于为客户提供更优质的低碳技术解决方案，推动碳中和目标的实现。',
        date: '2025-01-03',
        readTime: '3分钟阅读',
        image: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20for%20best%20low%20carbon%20technology%20service%20provider%20with%20professional%20team%20receiving%20recognition%2C%20corporate%20achievement%20celebration%2C%20business%20excellence%20award%20presentation%2C%20sustainable%20technology%20innovation%20conference&width=400&height=300&seq=news-006&orientation=landscape',
        tags: ['公司荣誉', '技术服务', '行业认可'],
        status: 'published'
      },
      {
        id: 7,
        category: '技术创新',
        title: 'AI人工智能在碳排放监测中的前沿应用',
        excerpt: '探索人工智能技术如何实现精准的碳排放监测和预测，为企业碳管理提供智能化解决方案。',
        content: '人工智能技术在碳排放监测领域的应用正在革命性地改变传统的监测模式。通过机器学习算法、深度学习网络等技术，可以实现对碳排放的实时监测、精准计算和智能预测。\n\n主要应用场景包括：工业生产过程碳排放实时监测、交通运输碳足迹智能计算、建筑能耗碳排放优化等。这些技术不仅提高了监测精度，还大大降低了监测成本。',
        date: '2024-12-28',
        readTime: '6分钟阅读',
        image: 'https://readdy.ai/api/search-image?query=AI%20artificial%20intelligence%20carbon%20emission%20monitoring%20with%20smart%20sensors%2C%20data%20analytics%20dashboards%2C%20machine%20learning%20algorithms%2C%20environmental%20monitoring%20technology%2C%20futuristic%20clean%20tech%20interface&width=400&height=300&seq=news-007&orientation=landscape',
        tags: ['人工智能', '碳监测', '智能化'],
        status: 'published'
      },
      {
        id: 8,
        category: '行业动态',
        title: '国际碳减排合作新机制助力全球气候目标实现',
        excerpt: '分析国际间碳减排合作的新机制和模式，探讨如何通过多边合作加速全球碳中和进程。',
        content: '随着全球气候治理进入新阶段，国际碳减排合作机制也在不断创新和完善。通过技术共享、资金支持、能力建设等多种形式的合作，发达国家和发展中国家正在构建更加公平有效的减排合作体系。\n\n新机制的特点包括：更加灵活的合作模式、更加透明的监测体系、更加公平的责任分担等。这些创新有助于调动各国积极性，推动全球碳中和目标的实现。',
        date: '2024-12-25',
        readTime: '7分钟阅读',
        image: 'https://readdy.ai/api/search-image?query=International%20carbon%20reduction%20cooperation%20mechanisms%20with%20global%20climate%20summit%2C%20diplomatic%20meetings%2C%20world%20map%20showing%20cooperation%20networks%2C%20sustainable%20development%20partnerships%2C%20climate%20action%20collaboration&width=400&height=300&seq=news-008&orientation=landscape',
        tags: ['国际合作', '减排机制', '气候目标'],
        status: 'published'
      },
      {
        id: 9,
        category: '案例分享',
        title: '绿色供应链管理的最佳实践案例研究',
        excerpt: '通过具体案例分析，展示企业如何通过绿色供应链管理实现全链条碳减排，提升竞争优势。',
        content: '绿色供应链管理已成为企业实现碳中和目标的重要途径。本案例研究了一家跨国消费品公司如何通过供应链绿色化改造，实现了整体碳排放降低35%的显著成效。\n\n该公司的主要做法包括：建立供应商绿色评价体系、推进包装材料循环利用、优化物流运输网络、实施数字化供应链管理等。这些举措不仅降低了环境影响，还提升了供应链效率和企业竞争力。',
        date: '2024-12-22',
        readTime: '8分钟阅读',
        image: 'https://readdy.ai/api/search-image?query=Green%20supply%20chain%20management%20best%20practices%20with%20sustainable%20logistics%2C%20eco-friendly%20packaging%2C%20renewable%20energy%20warehouses%2C%20carbon-neutral%20transportation%2C%20environmental%20supply%20chain%20optimization&width=400&height=300&seq=news-009&orientation=landscape',
        tags: ['供应链', '绿色管理', '最佳实践'],
        status: 'published'
      }
    ];
    
    // 只显示已发布的文章
    setArticles(initialArticles.filter(article => article.status === 'published'));
  }, []);

  // 滤选文章
  const filteredArticles = articles.filter(article => {
    const categoryMatch = selectedCategory === '全部' || article.category === selectedCategory;
    const searchMatch = searchTerm === '' || 
      article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      article.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
      article.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    return categoryMatch && searchMatch;
  });

  // 分页
  const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);
  const startIndex = (currentPage - 1) * articlesPerPage;
  const currentArticles = filteredArticles.slice(startIndex, startIndex + articlesPerPage);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setCurrentPage(1);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-emerald-50 to-blue-50 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                新闻资讯中心
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
                关注低碳技术行业动态，掌握绿色发展前沿趋势，获取专业服务资讯
              </p>
              
              {/* Search Bar */}
              <form onSubmit={handleSearch} className="max-w-xl mx-auto">
                <div className="relative">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="搜索文章标题、内容或标签..."
                    className="w-full px-6 py-4 pr-14 text-lg border-2 border-emerald-200 rounded-full focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors"
                  />
                  <button
                    type="submit"
                    className="absolute right-2 top-2 w-12 h-12 bg-emerald-600 text-white rounded-full hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
                  >
                    <i className="ri-search-line text-xl"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Category Filter */}
            <div className="mb-12">
              <div className="flex flex-wrap justify-center gap-4">
                {categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => {
                      setSelectedCategory(category);
                      setCurrentPage(1);
                    }}
                    className={`px-6 py-3 rounded-full font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                      selectedCategory === category
                        ? 'bg-emerald-600 text-white shadow-lg'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>

            {/* Articles Grid */}
            {currentArticles.length > 0 ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
                  {currentArticles.map((article) => (
                    <article key={article.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group border border-gray-100">
                      <div className="h-48 overflow-hidden">
                        <img 
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                        />
                      </div>
                      <div className="p-6">
                        <div className="flex items-center mb-3">
                          <span className="bg-emerald-100 text-emerald-600 px-3 py-1 rounded-full text-xs font-medium">
                            {article.category}
                          </span>
                          <span className="text-gray-400 text-xs ml-3">{article.date}</span>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-emerald-600 transition-colors cursor-pointer line-clamp-2">
                          {article.title}
                        </h3>
                        <p className="text-gray-600 mb-4 leading-relaxed line-clamp-3">
                          {article.excerpt}
                        </p>
                        <div className="flex items-center justify-between">
                          <div className="flex flex-wrap gap-2">
                            {article.tags.slice(0, 2).map((tag, index) => (
                              <span key={index} className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                #{tag}
                              </span>
                            ))}
                          </div>
                          <span className="text-xs text-gray-500">{article.readTime}</span>
                        </div>
                        <div className="mt-4 pt-4 border-t border-gray-100">
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={scrollToContact}
                            className="w-full"
                          >
                            <i className="ri-chat-3-line mr-2"></i>
                            了解详情
                          </Button>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="flex justify-center items-center space-x-2">
                    <button
                      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      className={`px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap ${
                        currentPage === 1
                          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                          : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
                      }`}
                    >
                      <i className="ri-arrow-left-line mr-1"></i>
                      上一页
                    </button>
                    
                    {[...Array(totalPages)].map((_, index) => {
                      const page = index + 1;
                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`w-10 h-10 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap ${
                            currentPage === page
                              ? 'bg-emerald-600 text-white'
                              : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    })}
                    
                    <button
                      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      className={`px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap ${
                        currentPage === totalPages
                          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                          : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
                      }`}
                    >
                      下一页
                      <i className="ri-arrow-right-line ml-1"></i>
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-16">
                <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-search-line text-3xl text-gray-400"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">未找到相关文章</h3>
                <p className="text-gray-600 mb-6">请尝试使用其他关键词搜索或选择不同的分类</p>
                <Button 
                  variant="outline"
                  onClick={() => {
                    setSearchTerm('');
                    setSelectedCategory('全部');
                    setCurrentPage(1);
                  }}
                >
                  <i className="ri-refresh-line mr-2"></i>
                  重置筛选
                </Button>
              </div>
            )}
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-gradient-to-r from-emerald-600 to-blue-600 py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              需要专业的低碳技术解决方案？
            </h2>
            <p className="text-xl text-emerald-100 mb-8">
              联系我们的专家团队，获取个性化的碳减排咨询服务
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                variant="secondary" 
                size="lg"
                onClick={scrollToContact}
              >
                <i className="ri-phone-line mr-2"></i>
                免费咨询：021-61091032
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                onClick={scrollToContact}
                className="bg-white/10 border-white/20 text-white hover:bg-white hover:text-emerald-600"
              >
                <i className="ri-mail-line mr-2"></i>
                在线咨询
              </Button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}